import InviteStage from '../../components/invite/InviteStage';
import InviteStore from '../../stores/InviteStore';
import InviteSuccess from '../../components/invite/InviteSuccess';
import InviteViewStyled from './InviteViewStyled';
import LoginRequired from '../../components/redeem/LoginRequired';
import PropTypes from 'prop-types';
import React from 'react';
import {connectToStores} from 'epic-alt-utils';
import queryString from 'query-string';

/**
 * InviteView
 *
 * Rendered when the Route matches /invite
 */
@connectToStores
class InviteView extends React.Component {
  static propTypes = {
    location: PropTypes.object,
    inviteStore: PropTypes.object,
    isLoggedIn: PropTypes.bool,
    loadScreen: PropTypes.node,
  };

  static getStores() {
    return [InviteStore];
  }

  static getPropsFromStores() {
    return {
      inviteStore: InviteStore.getState(),
    };
  }

  render() {
    const {isLoggedIn} = this.props;
    let inviteViewContent;
    if (!isLoggedIn || this.props.inviteStore.currentStage === 'LOGIN') {
      const code = this.props.location.search
        ? queryString.parse(this.props.location.search).code || ''
        : '';
      const loginPath = `${this.props.location.pathname}?code=${code}`;
      inviteViewContent = <LoginRequired returnPath={loginPath} signupDisabled />;
    } else {
      switch (this.props.inviteStore.currentStage) {
        case 'INVITE':
          inviteViewContent = (
            <InviteStage
              inviteStore={this.props.inviteStore}
              loadScreen={this.props.loadScreen}
              isLoggedIn={isLoggedIn}
              nextStage="SUCCESS"
            />
          );
          break;
        case 'SUCCESS':
          inviteViewContent = <InviteSuccess inviteStore={this.props.inviteStore} />;
          break;
        default:
          return true;
      }
    }
    return <InviteViewStyled className="inviteView">{inviteViewContent}</InviteViewStyled>;
  }
}

export default InviteView;
